/**
 * Pets Allowed Icon
 * 
 * Paw print icon indicating pet-friendly properties.
 * Uses Font Awesome for consistent, maintained icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaw } from '@fortawesome/free-solid-svg-icons/faPaw';
import type { IconProps } from '../../types';

export function PetsAllowedIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Pets Allowed',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faPaw}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
